import * as TabsPrimitive from "@radix-ui/react-tabs";
import { IconImac } from "central-icons/IconImac";
import { IconMoon } from "central-icons/IconMoon";
import { IconSun } from "central-icons/IconSun";
import { type FC } from "react";

/**
 * V2 of ThemeToggle - tab-based toggle optimized for the account settings modal.
 */
import { cn } from "@/components/podkit/lib/cn";
import { type Theme } from "@/contexts/ThemeProvider";
import { useTheme } from "@/hooks/use-theme";

const themeOptions: Theme[] = ["system", "light", "dark"];

export const ThemeToggleV2: FC = () => {
    const { theme, setTheme } = useTheme();
    return (
        <TabsPrimitive.Root value={theme} onValueChange={(value) => setTheme(value as Theme)}>
            <TabsPrimitive.List className="inline-flex gap-1 rounded-full border-0.5 border-border-base bg-surface-button-tab-base p-0.5">
                {themeOptions.map((t) => (
                    <TabsPrimitive.Trigger
                        key={t}
                        value={t}
                        aria-label={`${t} theme`}
                        className={cn(
                            "inline-flex h-7 items-center gap-1.5 rounded-full px-3 text-sm text-content-strong",
                            "data-[state=inactive]:hover:bg-surface-glass",
                            "data-[state=active]:bg-surface-button-tab-primary data-[state=active]:text-content-primary data-[state=active]:shadow-sm",
                        )}
                    >
                        <ThemeIcon theme={t} />
                        <span className="capitalize">{t}</span>
                    </TabsPrimitive.Trigger>
                ))}
            </TabsPrimitive.List>
        </TabsPrimitive.Root>
    );
};

const ThemeIcon: FC<{ theme: Theme }> = ({ theme }) => {
    switch (theme) {
        case "light":
            return <IconSun className="size-4" />;
        case "dark":
            return <IconMoon className="size-4" />;
        case "system":
            return <IconImac className="size-4" />;
    }
};
